export const ApplyEmployeeArr = [
  {
    path: "employee/:id(\\d+)",
    name: "employee/:id(\\d+)",
    meta: {
      title: "员工管理"
    },
    redirect: "/apply/employee/:id(\\d+)/employeeList",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "employeeList",
        name: "employeeList",
        meta: {
          title: "员工列表"
        },
        component: () => import("@/views/apply/employee/employeeList")
      },
      {
        path: "employeeAdd",
        name: "employeeAdd",
        meta: {
          title: "编辑员工"
        },
        component: () => import("@/views/apply/employee/employeeAdd")
      },
      {
        path: "role",
        name: "role",
        meta: {
          title: "角色管理"
        },
        component: () => import("@/views/apply/employee/role")
      },
      {
        path: "roleAdd",
        name: "roleAdd",
        meta: {
          title: "添加角色"
        },
        component: () => import("@/views/apply/employee/roleAdd")
      }
    ]
  }
];
